var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "650", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("person")]),
              _vm._v(" Editar usuario\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    { staticClass: "pt-0", attrs: { "grid-list-md": "" } },
                    [
                      _c("h4", [_vm._v("Datos de usuario")]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nombre de usuario",
                                  "prepend-icon": "person",
                                  maxlength: "50",
                                  autocomplete: "off",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  autofocus: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.nombre_usuario,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nombre_usuario", $$v)
                                  },
                                  expression: "form.nombre_usuario"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Correo electrónico",
                                  maxlength: "100",
                                  "prepend-icon": "email",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.correo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "correo", $$v)
                                  },
                                  expression: "form.correo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.sistemas,
                                  label:
                                    "Elija el sistema para obtener los roles",
                                  "item-text": "descripcion",
                                  "item-value": "id"
                                },
                                on: { change: _vm.getRoles }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  multiple: "",
                                  chips: "",
                                  items: _vm.roles,
                                  label: "Roles",
                                  "item-text": "descripcion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  "return-object": ""
                                },
                                model: {
                                  value: _vm.values,
                                  callback: function($$v) {
                                    _vm.values = $$v
                                  },
                                  expression: "values"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.cancel")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")))
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0035d42e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0035d42e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/usuario/dialogs/EditarUsuario.vue
// module id = null
// module chunks = 